import Team from '@scripts/modules/Teams/Team';

class Users {
  constructor(app) {
    this.app = app;
  }

  async setFollows(follows) {
    try {
      const data = new FormData();

      data.append('action', 'bvm_account_follow');
      data.append('mode', 'set');

      if (follows.locations) {
        for (const i in follows.locations) {
          data.append(`locations[${i}][postal]`, follows.locations[i].postal || 0);
          data.append(`locations[${i}][city]`, follows.locations[i].city || '');
          data.append(`locations[${i}][state]`, follows.locations[i].state || '');
        }
      }

      if (follows.teams) {
        for (const i in follows.teams) {
          data.append(`teams[${i}][id]`, follows.teams[i].id || 0);
          data.append(`teams[${i}][sport]`, follows.teams[i].sport || '');
          data.append(`teams[${i}][gender]`, follows.teams[i].gender || '');
        }
      }

      const response = await fetch(window.bvm.ajax, {
        method: 'POST',
        body: data,
      });

      if (! response.ok) {
        throw new Error(`[${response.status}] ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(error);
    }
  }

  async getFollows() {
    return {
      leagues: [],
      teams: await this.getTeams(),
    };
  }

  async getTeams() {
    const items = [];

    if (window.bvm.user.teams.length === 0) {
      return items;
    }

    const teams = await window.bvm.app.teams.get({
      nonce: window.bvm.rest_nonce,
      ids: [...new Set(window.bvm.user.teams.map((item) => item.id))],
      limit: 1000,
      custom: ['local-order'],
    });

    if (teams.total === 0) {
      return items;
    }

    for (const choice of window.bvm.user.teams) {
      const index = teams.data.findIndex(result => result.getId() === choice.id);

      if (index < 0) {
        continue;
      }

      if (! items[index]) {
        items[index] = [];
      }

      const team = teams.data[index];

      if (team.hasSquads()) {
        if (choice.sport === '' && choice.gender === '') {
          items[index].unshift(team);
        } else {
          team.getSquads().forEach((squad) => {
            if (squad.sport === choice.sport && squad.gender === choice.gender) {
              items[index].unshift(
                new Team()
                  .setId(team.getId())
                  .setSsId(team.getSsId())
                  .setTitle(team.getTitle())
                  .setShortTitle(team.getShortTitle())
                  .setSubtitle(squad.title.replace('Men\'s', 'M.').replace('Women\'s', 'W.').replace('Girls', 'G.').replace('Boys', 'B.'))
                  .setSlug(squad.slug)
                  .setUrl(squad.url)
                  .setLevel(team.getLevel())
                  .setLeague(team.getLeague())
                  .setLogo(team.getLogo())
                  .setLogoHTML(team.getLogoHTML())
                  .setAddress(team.getAddress())
                  .setSport(squad.sport)
                  .setGender(squad.gender)
                  .setMascot(team.getMascot())
              );
            }
          });
        }
      } else {
        items[index].unshift(team);
      }
    }

    return items.flat();
  }
}

export default Users;
